import { render, staticRenderFns } from "./CtaBox.vue?vue&type=template&id=04fff982&"
import script from "./CtaBox.vue?vue&type=script&lang=js&"
export * from "./CtaBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports